import { gql } from '@apollo/client';
import { getProductFragment } from '../product/getProductQuery';

const getDynamicRecs = ({ domains = ['fbt'], productDomains = [] }) => {

  const productFragments = getProductFragment({ domains: productDomains });

  const fragments = domains.map((type) => {
    if (type === 'package') {
      return `
      fragment BundleMeta on PackageBundle {
        metadata {
          title
          brandName
          name
          image {
            url
          }
          heroImage {
              url
          }
          brandImage {
              url
          }
          __typename
        }
      }
      fragment BundleProductResponse on PackageBundle {
        products {
          ${productFragments.queryUnwrapped}
        }
      }
      `;
    }
    if (type === 'irg') {
      return `
        fragment IRGSubQuery on BundleResponse {
          irg(maxItems: $maxItems) {
              collection {
                  ...BundleMeta
                  categories {
                      category
                      itemIds
                      __typename
                  }
                  ...BundleProductResponse
                  __typename
              }
              accessories {
                  ...BundleMeta
                  categories {
                      category
                      itemIds
                      __typename
                  }
                  ...BundleProductResponse
                  __typename
              }
              coordinatingItems {
                  ...BundleMeta
                  categories {
                      category
                      itemIds
                      __typename
                  }
                  ...BundleProductResponse
                  __typename
              }
              __typename
          }
        }`;
    }

    if (type === 'bundle') {
      return `
      fragment BundleMeta on Bundle {
        metadata {
          apiName
          title
          version
          __typename
        }
        __typename
      }

      fragment BundleProductResponse on Bundle {
        products {
          product {
            ${productFragments.query}
          }
          anchorCategory
          category
          description
          isAnchor
          slot {
            name
            description
            isRequired
          }
          __typename
        }
        __typename
      }
      `;
    }

    return `
      fragment BundleMeta on Bundle {
        metadata {
          apiName
          title
          version
          modelName
          fallbackModelName
          __typename
        }
        __typename
      }

      fragment BundleProductResponse on Bundle {
        products {
          product {
            ${productFragments.query}
          }
          anchorIdTitle
          anchorIdIsPromo
          idPromoDetails
          strategygroup
          score
          stack
          strategy
          model
          idEndDate
          idStartDate
          anchorCategory
          anchorCategoryGuid
          category
          categoryGuid
          __typename
        }
        __typename
      }
    `;
  });

  const query = domains.map((type) => {

    if (type === 'package') {
      return `
      package {
        ...BundleMeta
        ...BundleProductResponse
        __typename
        }
      `;
    }
    if (type === 'irg') {
      return `
        ...IRGSubQuery
      `;
    }

    return `
    ${type} {
          ...BundleMeta
          ...BundleProductResponse
        }
    `;
  });
  const params = [
    '$itemId: String!',
    '$storeId: String'
  ];
  if (domains.indexOf('irg') > -1) {
    params.push('$maxItems: Int');
  }

  const DynamicRecsQuery = `
    query DynamicRecs(${params.join(', ')}) {
      dynamicRecs(itemId: $itemId, storeId: $storeId) {
        ${query}
      }
    }
    ${productFragments.fragments}
    ${fragments.join('\n')}
`;
  return gql(DynamicRecsQuery);
};
export default getDynamicRecs;
